module.exports = __webpack_public_path__ + "img/eyebrow-3.6fefdfad.svg";